howspace.components.filterInfo = (() => {
    'use strict';

    const addFilter = (filterInfo, type, title, value) => {
        const filtersWrapper = filterInfo.find('.filters');

        const template = howspace.template.getHtml(filterInfo.find('template'), {
            type: type,
            title: title,
            value: value
        });

        filtersWrapper.append(template);
    };

    const removeFilter = (e) => {
        const filter = $(e.currentTarget).closest('.howspace-filter');
        const container = filter.closest('.howspace-filter-info');
        const type = filter.data('type');
        const value = filter.data('value').toString();
        const widget = filter.closest('.widget');

        howspace.widgets.removeFilter(widget, type, value);

        filter.remove();

        if (container.find('.filters .howspace-filter').length === 0) {
            container.addClass('d-none');
        }
    };

    const removeFilters = (e) => {
        const widget = $(e.currentTarget).closest('.widget');

        howspace.widgets.clearFilters(widget);
        howspace.widgets.saveFilter(widget, null);
    };

    const saveFilters = (e) => {
        const widget = $(e.currentTarget).closest('.widget');

        howspace.widgets.saveFilter(widget);
    };

    const disableCheckboxes = (lister) => {
        lister.find('.howspace-form-checkbox').each(function () {
            const checkbox = $(this);
            const input = checkbox.find('input');

            if (!input.prop('checked')) {
                checkbox.addClass('disabled');
                input.prop('disabled', true);
            }
        });
    };

    const enableCheckboxes = (lister) => {
        lister.find('.howspace-form-checkbox').each(function () {
            const checkbox = $(this);
            const input = checkbox.find('input');

            if (!input.hasClass('filter-disabled')) {
                checkbox.removeClass('disabled');
                input.prop('disabled', false);
            }
        });
    };

    const handleItemsLoaded = (e) => {
        const lister = $(e.target);

        if (lister.find('input:checked').length > 0) {
            disableCheckboxes(lister);
        }
    };

    const updateWidgetFilters = (modal, widget) => {
        const filterInfo = widget.find('.howspace-filter-info');
        const filtersWrapper = filterInfo.find('.filters');

        filtersWrapper.find('.howspace-filter').remove();

        let filter = {};

        modal.find('input:checked').each(function () {
            const input = $(this);
            const type = input.data('filter-type');
            const value = input.data('filter-value');
            const title = input.data('display-title');

            if (filter[type]) {
                filter[type] = filter[type] + ',' + value;
            } else {
                filter[type] = value;
            }

            addFilter(filterInfo, type, title, value);
        });

        if (JSON.stringify(filter) !== '{}') {
            filterInfo.find('.save-filters-btn').removeClass('d-none');
            filterInfo.removeClass('d-none');

            howspace.widgets.setFilter(widget, filter);
        }
    };

    const showFilteringModal = (widget) => {
        howspace.components.modal.show(howspace.widgets.getUrl(widget) + '/filtering-modal', (modal) => {
            modal = $(modal);

            modal.on(howspace.components.lister.LIST_ITEMS_LOADED, handleItemsLoaded);

            modal.find('.btn-success').on('click', () => {
                updateWidgetFilters(modal, widget);

                howspace.components.modal.close(modal);
            });
        });
    }

    return {
        init: (elem) => {
            elem.findIncludingSelf('.howspace-filter-info:not(.howspace-filter-info-initialized)').each(function () {
                const filterInfo = $(this);

                filterInfo.addClass('howspace-filter-info-initialized');

                filterInfo.on('click', '.remove-filter-btn', removeFilter);
                filterInfo.find('.remove-filters-btn').on('click', removeFilters);
                filterInfo.find('.save-filters-btn').on('click', saveFilters);

                const widget = filterInfo.closest('.widget');

                widget.find('.show-filtering-modal-btn').on('click', () => {
                    showFilteringModal(widget);
                });
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-image-editor.howspace-image-editor-initialized').each(function () {
                const filterInfo = $(this);
                filterInfo.removeClass('howspace-filter-info-initialized');
            });
        },
        filterByAnnotation: (filterInfo, widget, value) => {
            if (value) {
                const type = 'annotation';
                const filter = filterInfo.find('.howspace-filter[data-type="annotation"]');

                if (filter.length > 0) {
                    filter.dataAndAttr('value', value);
                } else {
                    addFilter(filterInfo, type, howspace.translate('common_filter_annotation'), value);
                }

                howspace.widgets.addFilter(widget, type, value);

                filterInfo.find('.save-filters-btn').addClass('d-none');
                filterInfo.removeClass('d-none');
            } else {
                filterInfo.find('.howspace-filter[data-type="annotation"] .btn').trigger('click');
            }
        }
    }
})();
